module.exports = __webpack_public_path__ + "static/media/bg_10.b7e84931.png";